// @ts-check
import isString from 'lodash/isString';

function isValidTwitterName(accountName) {
  if (!accountName || !isString(accountName)) {
    return false;
  }
  const invalidCharacters = /[^a-zA-Z0-9_.]/;
  return !invalidCharacters.test(accountName);
}

export default isValidTwitterName;
